<template>
  <div>
    <b-form-textarea
      v-bind="$attrs"
      :value="value"
      :maxlength="maxlength"
      @input="$emit('input', $event)"
    />
    <small
      class="d-block text-right mt-25"
      :class="length >= maxlength ? 'text-danger' : 'text-muted'"
    >
      {{ length }}/{{ maxlength }}
    </small>
  </div>
</template>

<script>
import { BFormTextarea } from "bootstrap-vue";

// Textarea con límite de caracteres y contador "0/N" para los formularios de mesa de ayuda.
export default {
  name: "CountedTextarea",
  components: { BFormTextarea },
  inheritAttrs: false,
  props: {
    value: { type: String, default: "" },
    maxlength: { type: Number, required: true },
  },
  computed: {
    length() {
      return (this.value || "").length;
    },
  },
};
</script>
